import { CSSProperties } from 'react';

type SizeProps = {
  size: number;
  strokeWidth: number;
  milliseconds: number;
  circumference: number;
};

export const getSizeStyles = ({
  size,
  strokeWidth,
  milliseconds,
  circumference
}: SizeProps): CSSProperties => {
  return {
    '--width': `${size}px`,
    '--height': `${size}px`,
    '--stroke-width-inner': `${strokeWidth / 2}px`,
    '--stroke-width': `${strokeWidth}px`,
    '--max-seconds': `${milliseconds / 1000}s`,
    '--max-stroke-dashoffset': circumference
  } as CSSProperties;
};
